<template>
  <div>
    <div v-if="haveRight">
      <div class="container">
        <div class="weui-cells__title order-no">寄件单号： {{expressTakein.orderNo?expressTakein.orderNo:'请扫描'}}
          <span v-if="!expressTakein.isDaofu && expressTakein._id">（{{expressTakein.freightPay?'已付运费':'待付运费'}}）</span>
          <span v-if="expressTakein.isDaofu">（到付运费）</span>
        </div>
        <div v-if="needToAuth">
          <article class="weui-article">
            <h1 style="text-align:center; font-weight: bold;">{{jijianUser.toAuthRealname}}
              <span>待审核</span>
            </h1>
            <h2 style="text-align:center; font-weight: bold;">{{jijianUser.toAuthIdCardNo}}</h2>
            <h2 style="margin-top: 20px;">1.1 身份证照片</h2>
            <p>
              <img :src="jijianUser.idCardUrl" alt="">
            </p>
            <h2 v-if="jijianUser.studentCardUrl">1.2 学生证照片</h2>
            <p>
              <img :src="jijianUser.studentCardUrl" alt="">
            </p>
          </article>
          <div style="display: flex;">
            <div class="footer-item verify-no" style="flex:1" @click="verifyNo">
              <a href="javascript:;">审核不通过</a>
            </div>
            <div class="footer-item verify-yes" style="flex:1" @click="verifyYes">
              <a href="javascript:;">审核通过</a>
            </div>
          </div>
        </div>
        <div v-if="!needToAuth">
          <section class="mail-toandget">
            <div class="mail-to mail-item">
              <div class="mail-item-left">
                <span class="jijian">寄</span>
              </div>
              <div class="mail-item-middle mail-item-middle_jijian">
                <div>
                  <div>
                    <p>
                      <span class="mail-user">{{expressTakein.sender?expressTakein.sender:'寄件人'}}</span>
                      <span>{{expressTakein.senderPhone?expressTakein.senderPhone:'138 **** ****'}}</span>
                    </p>
                    <p>{{expressTakein.senderAddress?expressTakein.senderAddress:'寄件人地址'}}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="mail-get mail-item">
              <div class="mail-item-left">
                <span class="shoujian">收</span>
              </div>
              <div class="mail-item-middle mail-item-middle_shoujian">
                <div>
                  <p>
                    <span class="mail-user">{{expressTakein.receiver?expressTakein.receiver:'收件人'}}</span>
                    <span>{{expressTakein.receiverPhone?expressTakein.receiverPhone:'138 **** ****'}}</span>
                  </p>
                  <p>{{expressTakein.receiverAddress?expressTakein.receiverAddress:'收件人地址'}}</p>
                </div>
              </div>
            </div>
          </section>
          <div class="weui-cell">
            <div class="weui-cell__bd">
              <p>待寄物品</p>
            </div>
            <div class="weui-cell__ft">{{expressTakein.goodsName?expressTakein.goodsName:'物品'}} x{{expressTakein.goodsCount?expressTakein.goodsCount:1}}</div>
          </div>
          <div class="weui-cell" v-if="expressTakein.insureMoney">
            <div class="weui-cell__bd">
              <p>保价费用
                <span style="font-size: 12px; color: orangered;">（保价金额：{{expressTakein.insureMoney}} 元）</span>
              </p>
            </div>
            <div class="weui-cell__ft">{{insureFreight}} 元</div>
          </div>
          <div class="weui-cell" v-if="expressTakein.remark">
            <div class="weui-cell__bd">
              <p>寄件备注</p>
            </div>
            <div class="weui-cell__ft">{{expressTakein.remark}}</div>
          </div>
          <div class="weui-cell" v-if="!expressTakein._id || expressTakein.freightPay">
            <div class="weui-cell__bd">
              <p>快递公司</p>
            </div>
            <div class="weui-cell__ft">{{currExpressSendCompany.name?currExpressSendCompany.name:'待扫单'}}</div>
          </div>
          <a class="weui-cell weui-cell_access" href="javascript:;" v-if="expressTakein._id && !expressTakein.freightPay" @click="chooseExpress">
            <div class="weui-cell__bd">
              <p>快递公司</p>
            </div>
            <div class="weui-cell__ft">{{currExpressSendCompany.name?currExpressSendCompany.name:'请选择'}}</div>
          </a>
          <div class="weui-cell weui-cell_switch" v-if="showDaofu">
            <div class="weui-cell__bd">运费到付</div>
            <div class="weui-cell__ft">
              <label for="switchDaofu" class="weui-switch-cp">
                <input id="switchDaofu" class="weui-switch-cp__input" type="checkbox" v-model="expressTakein.isDaofu" @click="daofu" />
                <div class="weui-switch-cp__box"></div>
              </label>
            </div>
          </div>
          <div class="weui-cell">
            <div class="weui-cell__bd">
              <p>支付方式</p>
            </div>
            <div class="weui-cell__ft">{{expressTakein.isDaofu?"到付":"现付"}}</div>
          </div>
          <div class="weui-cell" v-if="(!expressTakein._id || expressTakein.freight || expressTakein.freightPay) && !expressTakein.isDaofu">
            <div class="weui-cell__bd">
              <p>计费重量</p>
            </div>
            <div class="weui-cell__ft">{{expressTakein.freightPay?expressTakein.freightWeight+'kg':'待扫单'}}</div>
          </div>
          <div class="weui-cell weui-cell_vcode" v-if="expressTakein._id && !expressTakein.freight && !expressTakein.freightPay && !expressTakein.isDaofu">
            <div class="weui-cell__hd">
              <label class="weui-label">计费重量</label>
            </div>
            <div class="weui-cell__bd">
              <input class="weui-input" type="number" v-model="expressTakein.freightWeight" placeholder="请输入待寄物品重量" @blur="clearFreight" style="text-align: right;" />
            </div>
            <div class="weui-cell__ft">
              <button class="weui-vcode-btn">kg</button>
            </div>
            <div class="weui-cell__ft" @click="getFreight">
              <button class="weui-vcode-btn" style="color: #fff; background-color: #1aad19;">计 费</button>
            </div>
          </div>
          <div class="weui-cell" v-if="(!expressTakein._id || expressTakein.freight || expressTakein.freightPay) && !expressTakein.isDaofu">
            <div class="weui-cell__bd">
              <p>合计运费</p>
            </div>
            <div class="weui-cell__ft">{{expressTakein.freightPay?(expressTakein.freight+insureFreight*100) / 100:'待扫单'}}</div>
          </div>
          <div class="weui-cell" v-if="expressTakein._id && !expressTakein.freight && !expressTakein.freightPay && !expressTakein.isDaofu">
            <div class="weui-cell__hd">
              <label class="weui-label">合计运费</label>
            </div>
            <div class="weui-cell__bd">
              <input class="weui-input" type="number" v-model="freight" placeholder="请输入运费" style="text-align: right;" />
            </div>
          </div>
          <div style="display: flex;">
            <div class="footer-item" :class="feeBntAble?'fee-able-yes':'fee-able-no'" style="flex:1; border-right: 1px solid #eee;" @click="addFreight">
              <a href="javascript:;">
                <i class="weui-loading" v-if="isUpdatingFreight"></i> 确认运费</a>
            </div>
            <div class="footer-item" :class="printBntAble?'print-able-yes':'print-able-no'" style="flex:1" @click="print">
              <a href="javascript:;">
                <i class="weui-loading" v-if="isPrinting"></i> 打印面单</a>
            </div>
          </div>
        </div>
      </div>
      <div class="scan-container" v-if="!needToAuth">
        <div class="scan-bnt" @click="scan">
          <i class="iconfont icon-saomiaoshibie380" style="font-size: 36px;"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from "../../config/config.js";
import weui from "weui.js";
import axios from "axios";
const wx = require("weixin-js-sdk");
import io from "socket.io-client";

export default {
  data() {
    return {
      haveRight: false,
      encodeToken: "",
      token: "",
      worksiteId: "",
      jijianUser: {},
      needToAuth: false,
      expressTakein: {},
      insureFreight: 0,
      tempFreightWeight: 0,
      freight: "",
      expressSendCompanies: [],
      feeBntAble: false,
      feeBntLabel: "确认运费",
      printBntAble: false,
      printBntLabel: "打印面单",
      isUpdatingFreight: false,
      isPrinting: false,
      escPicker: [
        {
          label: "请选择",
          code: "",
          value: ""
        }
      ],
      currExpressSendCompany: {},
      showDaofu: false
    };
  },
  created() {
    let that = this;
    this.encodeToken = this.$route.params.token;
    this.token = decodeURIComponent(this.encodeToken);
    axios.defaults.headers["Authorization"] = "Bearer " + this.token;

    let url = window.location.href;
    let params = {
      url: url
    };
    let jsConfig = {};
    axios
      .get("/api/wx/jsconfig", { params })
      .then(res => {
        jsConfig = res.data.data;
        jsConfig.jsApiList = ["scanQRCode"];
        wx.config(jsConfig);
      })
      .catch(err => {
        console.log(err);
      });

    // 建立 socket 连接
    const socket = io(config.socket, {
      transports: ["websocket"]
    });
    // 建立 socket 连接
    socket.on("connect", function() {
      console.log("socket.io connect...");
    });
    socket.on("reconnect_attempt", () => {
      socket.io.opts.transports = ["websocket", "polling"];
    });
    socket.on("freightUpdated", function(_id) {
      if (that.expressTakein._id == _id) {
        if (that.isUpdatingFreight) {
          that.isUpdatingFreight = false;
        }
      }
    });
    socket.on("freightPaySuccess", function(_id) {
      if (that.expressTakein._id == _id) {
        that.printBntAble = true;
        that.expressTakein.freightPay = true;
      }
    });
    socket.on("freightPaySuccessDaofu", function(msg) {
      if (that.expressTakein._id == msg._id) {
        that.printBntAble = true;
        that.expressTakein.freightPay = true;
        that.currExpressSendCompany.name = msg.expressCompanyName;
      }
    });
    socket.on("expressTakeinCancel", function(_id) {
      if (that.expressTakein._id == _id) {
        weui.alert("该预约单已经被用户取消");
        that.printBntAble = false;
        that.expressTakein = {};
        that.isPrinting = false;
        that.freight = "";
        that.currExpressSendCompany = {};
      }
    });

    axios
      .get("/api/user/wxuserInfo")
      .then(response => {
        let openid = response.data.data.openid;
        let userInfo = response.data.data;
        // 根据openid 获取后台用户信息
        axios
          .get("/auth/employee/getByOpen/" + openid)
          .then(employeeRes => {
            if (employeeRes.data.success) {
              that.haveRight = true;

              let printer150Ip = userInfo.worksite.printer150Ip;
              let printer150Port = userInfo.worksite.printer150Port;
              let oscript150 = document.getElementsByName("lodopurl")[0];
              oscript150.src =
                "http://" +
                printer150Ip +
                ":" +
                printer150Port +
                "/CLodopfuncs.js?name=LODOP150";

              let printer180Ip = userInfo.worksite.printer180Ip;
              let printer180Port = userInfo.worksite.printer180Port;
              let oscript180 = document.getElementsByName("lodopurl")[1];
              oscript180.src =
                "http://" +
                printer180Ip +
                ":" +
                printer180Port +
                "/CLodopfuncs.js?name=LODOP180";

              that.worksiteId = userInfo.worksite._id;

              // 根据worksiteId 获取当前可用的寄件快递列表
              axios
                .get("/api/worksite/detail/" + that.worksiteId)
                .then(res => {
                  that.expressSendCompanies =
                    res.data.data.expressSendCompanies;
                  for (let i = 0; i < that.expressSendCompanies.length; i++) {
                    let item = {
                      label: that.expressSendCompanies[i].name,
                      value: that.expressSendCompanies[i]._id,
                      code: that.expressSendCompanies[i].code,
                      surfaceHeight: that.expressSendCompanies[i].surfaceHeight,
                      surfaceWidth: that.expressSendCompanies[i].surfaceWidth
                    };
                    that.escPicker.push(item);
                  }
                })
                .catch(err => {
                  weui.topTips("获取可用寄件快递列表失败", 2000);
                });
            } else {
              weui.alert("请先绑定后台操作用户", function() {
                that.$router.push("/bind/takepart/" + that.encodeToken);
              });
            }
          })
          .catch(employeeErr => {
            weui.topTips("获取用户信息失败", 2000);
          });
      })
      .catch(error => {
        weui.topTips("获取用户信息失败", 2000);
      });
  },
  methods: {
    verifyNo() {
      axios
        .put("/api/user/verifyauth/" + this.jijianUser._id, { authStatus: 2 })
        .then(res => {
          if (res.data.success) {
            this.expressTakein = {};
            this.needToAuth = false;
          } else {
            weui.alert("审核出错");
          }
        })
        .catch(err => {
          weui.alert("审核出错");
        });
    },
    verifyYes() {
      axios
        .put("/api/user/verifyauth/" + this.jijianUser._id, { authStatus: 1 })
        .then(res => {
          if (res.data.success) {
            this.needToAuth = false;
          } else {
            weui.alert("审核出错");
          }
        })
        .catch(err => {
          weui.alert("审核出错");
        });
    },
    scan() {
      let that = this;
      wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
        success: function(res) {
          let orderNo = res.resultStr; // 当needResult 为 1 时，扫码返回的结果

          axios
            .get("/api/expressTakein/getByOrderNo/" + orderNo)
            .then(res => {
              if (res.data.success) {
                let senderOpneid = res.data.data.senderOpenid;
                // 根据OPENID 获取用户信息，查看该用户是否已经实名认证
                axios
                  .get("/api/user/userInfoByOpenid/" + senderOpneid)
                  .then(userRes => {
                    if (userRes.data.success) {
                      that.jijianUser = userRes.data.data;
                      let authStatus = userRes.data.data.authStatus;
                      if (authStatus == -1 || authStatus == 2) {
                        weui.alert("用户还没通过实名认证");
                      } else {
                        if (authStatus == 0) {
                          that.needToAuth = true;
                        }
                        that.expressTakein = res.data.data;

                        if (that.expressTakein.insureMoney) {
                          let fee =
                            (that.expressTakein.insureMoney *
                              config.insurePercent) /
                            100;
                          // 使用进一法
                          that.insureFreight = Math.ceil(fee);
                        }

                        if (that.expressTakein.expressCompany) {
                          that.currExpressSendCompany =
                            that.expressTakein.expressCompany;
                        }
                        if (that.expressTakein.freight) {
                          that.tempFreightWeight =
                            that.expressTakein.freightWeight;
                          that.freight = that.expressTakein.freight / 100;
                        }
                        if (!that.expressTakein.freightPay) {
                          that.feeBntAble = true;
                        }
                        if (that.expressTakein.freightPay) {
                          that.printBntAble = true;
                        } else {
                          if (that.expressTakein.freight) {
                            weui.alert("寄件客户还没付运费");
                          }
                        }
                      }
                    } else {
                      weui.alert("获取寄件用户信息出错");
                    }
                  })
                  .catch(userErr => {
                    weui.alert("获取寄件用户信息出错");
                  });
              } else {
                weui.alert("查找寄件信息出错");
              }
            })
            .catch(err => {
              weui.alert("查找寄件信息出错");
            });
        }
      });
    },
    chooseExpress() {
      let that = this;
      weui.picker(this.escPicker, {
        className: "custom-classname",
        container: "body",
        defaultValue: [
          that.expressTakein.expressCompany
            ? that.expressTakein.expressCompany._id
            : ""
        ],
        onChange: function(result) {},
        onConfirm: function(result) {
          that.currExpressSendCompany = {
            _id: result[0].value,
            code: result[0].code,
            name: result[0].label,
            surfaceHeight: result[0].surfaceHeight,
            surfaceWidth: result[0].surfaceWidth
          };

          if (that.currExpressSendCompany.name == "顺丰速运") {
            // 显示到付按钮
            that.showDaofu = true;
          } else {
            that.showDaofu = false;
            that.expressTakein.isDaofu = false;
          }

          if (that.expressTakein.freightWeight) {
            let params = {
              worksiteId: that.worksiteId,
              expressCode: that.currExpressSendCompany.code,
              fromProvinceCode: that.expressTakein.senderProvince.code,
              toProvinceCode: that.expressTakein.receiverProvince.code,
              freightWeight: that.expressTakein.freightWeight
            };

            // 获取运费
            axios
              .get("/api/expressFreight/freight", { params })
              .then(res => {
                if (res.data.success) {
                  that.freight = res.data.data + that.insureFreight;
                } else {
                  that.freight = "";
                  weui.alert(res.data.message);
                }
              })
              .catch(err => {
                that.freight = "";
                weui.alert("自动计算运费失败，请手动输入");
              });
          }
        },
        id: "expressSendCompanyPicker"
      });
    },
    daofu() {
      if (!this.expressTakein.isDaofu) {
        this.feeBntAble = true;
      } else {
        if (!this.expressTakein.freightPay) {
          this.feeBntAble = true;
        } else {
          this.feeBntAble = false;
        }
        this.freight = "";
        this.expressTakein.freightWeight = "";
      }
    },
    clearFreight() {
      if (this.expressTakein.freightWeight != this.tempFreightWeight) {
        this.freight = "";
      }
    },
    getFreight() {
      if (this.expressTakein.freightWeight && this.currExpressSendCompany._id) {
        let params = {
          worksiteId: this.worksiteId,
          expressCode: this.currExpressSendCompany.code,
          fromProvinceCode: this.expressTakein.senderProvince.code,
          toProvinceCode: this.expressTakein.receiverProvince.code,
          freightWeight: this.expressTakein.freightWeight
        };

        // 获取运费
        axios
          .get("/api/expressFreight/freight", { params })
          .then(res => {
            if (res.data.success) {
              this.freight = res.data.data + this.insureFreight;
            } else {
              weui.alert(res.data.message);
            }
          })
          .catch(err => {
            weui.alert("自动计算运费失败，请手动输入");
          });
      }
    },
    addFreight() {
      if (
        this.expressTakein._id &&
        !this.expressTakein.freight &&
        !this.expressTakein.freightPay
      ) {
        if (this.expressTakein.isDaofu) {
          // 如果是到付，则按照到付逻辑更新数据
          if (!this.currExpressSendCompany._id) {
            weui.alert("请选择快递公司");
            return;
          }
          this.isUpdatingFreight = true;
          let params = {
            id: this.expressTakein._id,
            expressCompanyId: this.currExpressSendCompany._id
          };
          axios
            .put("/api/expressTakein/freight/updateFreightDaofu", params)
            .then(res => {
              this.isUpdatingFreight = false;
              if (res.data.success) {
                this.feeBntAble = false;
                this.showDaofu = false;
                weui.toast("到付成功待打印");
              } else {
                weui.alert("更新运费失败");
              }
            })
            .catch(err => {
              this.isUpdatingFreight = false;
              weui.alert("更新运费失败");
            });
        } else {
          if (!this.currExpressSendCompany._id) {
            weui.alert("请选择快递公司");
            return;
          } else if (!this.expressTakein.freightWeight) {
            weui.alert("请输入计费重量");
            return;
          } else if (!this.freight) {
            weui.alert("点击计费或手动输入运费");
            return;
          }

          this.isUpdatingFreight = true;

          let params = {
            id: this.expressTakein._id,
            expressCompanyId: this.currExpressSendCompany._id,
            freightWeight: this.expressTakein.freightWeight,
            freight: this.freight * 100
            // freight: 1
          };
          axios
            .put("/api/expressTakein/freight/updateFreight", params)
            .then(res => {
              this.isUpdatingFreight = false;
              if (res.data.success) {
                this.expressTakein = res.data.data;
                this.feeBntAble = false;
                weui.toast("计费成功待支付");
              } else {
                weui.alert("更新运费失败");
              }
            })
            .catch(err => {
              this.isUpdatingFreight = false;
              weui.alert("更新运费失败");
            });
        }
      }
    },
    print() {
      if (this.expressTakein.freightPay && !this.isPrinting) {
        this.isPrinting = !this.isPrinting;
        let params = {
          orderNo: this.expressTakein.orderNo,
          expressCompanyId: this.currExpressSendCompany._id,
          expressCompanyCode: this.currExpressSendCompany.code
        };

        let surfaceHeight = this.currExpressSendCompany.surfaceHeight;
        let surfaceWidth = this.currExpressSendCompany.surfaceWidth;

        axios
          .post("/api/common/getElecWaybill/", {
            params
          })
          .then(res => {
            if (res.data.success) {
              let html = res.data.data.PrintTemplate;
              if (surfaceHeight == 180) {
                LODOP180.ADD_PRINT_HTM(
                  0,
                  0,
                  surfaceWidth + "mm",
                  surfaceHeight + "mm",
                  html
                );
                LODOP180.SET_LICENSES(
                  "北京易普联科信息技术有限公司",
                  "653717070728688778794958093190",
                  "",
                  ""
                );
                LODOP180.PRINT();
              } else if (surfaceHeight == 150) {
                LODOP150.ADD_PRINT_HTM(
                  0,
                  0,
                  surfaceWidth + "mm",
                  surfaceHeight + "mm",
                  html
                );
                LODOP150.SET_LICENSES(
                  "北京易普联科信息技术有限公司",
                  "653717070728688778794958093190",
                  "",
                  ""
                );
                LODOP150.PRINT();
              }

              this.isPrinting = !this.isPrinting;
              this.expressTakein = {};
              this.printBntAble = false;
              this.freight = "";
              this.currExpressSendCompany = {};
            } else {
              weui.alert(res.data.message);
              this.isPrinting = !this.isPrinting;
            }
          })
          .catch(err => {
            this.isPrinting = !this.isPrinting;
            weui.alert("打印失败，请检查打印机状态。");
          });
      }
    }
  }
};
</script>

<style scoped>
.order-no {
  font-size: 16px;
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
}
.order-no span {
  color: red;
}
.container {
  font-size: 16px;
}
.scan-container {
  width: 100%;
  display: flex;
  align-items: center;
}
.scan-bnt {
  width: 80px;
  height: 80px;
  position: fixed;
  bottom: 20px;
  left: 0px;
  right: 0px;
  margin-left: auto;
  margin-right: auto;
  color: #1aad19;
  text-align: center;
  line-height: 80px;
  border-radius: 40px;
  font-size: 22px;
  box-shadow: 0px 0px 20px #1aad19;
  background-color: #fff;
}
.mail-item {
  display: flex;
  align-items: center;
  padding: 8px 0px;
}
.mail-item + .mail-item {
  border-top: 1px solid #eee;
}
.mail-item-left {
  width: 50px;
}
.jijian {
  padding: 10px;
  border-radius: 100%;
  background-color: #1aad19;
  color: white;
}
.shoujian {
  padding: 10px;
  border-radius: 100%;
  background-color: red;
  color: white;
}
.mail-item-middle {
  flex: 1;
  text-align: left;
}
.mail-item-middle .weui-cell {
  padding-left: 0px;
}
.weui-cell_address {
  font-size: 14px;
}
.mail-toandget {
  margin-left: 15px;
  margin-right: 15px;
}
.mail-toandget p {
  padding: 3px 0px;
}
.mail-user {
  font-size: 18px;
  font-weight: bold;
}
.footer-item {
  flex: 1;
  font-size: 18px;
  text-align: center;
  line-height: 50px;
}
.footer-item a {
  color: #ffffff;
}
.fee-able-no {
  background-color: grey;
}
.fee-able-yes {
  background-color: orangered;
}
.verify-no {
  background-color: orangered;
}
.verify-yes {
  background-color: dodgerblue;
}
.print-able-no {
  background-color: grey;
}
.print-able-yes {
  background-color: dodgerblue;
}
h1 > span {
  background-color: #1aad19;
  color: #fff;
  margin-left: 10px;
  font-size: 14px;
  padding: 2px 4px;
  border-radius: 4px;
}
</style>
<style>
.weui-picker__item {
  font-size: 18px !important;
}
</style>





// WEBPACK FOOTER //
// src/components/operations/PrintSurface.vue